import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import { resultCards } from '@/mocks/about';

export default function ResultsBridge() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            Proof
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            The Strategy Is Personal. The Results Are Measurable.
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-5">
          {resultCards.map((card, i) => (
            <Reveal key={card.label} delay={i * 80}>
              <div className="h-full rounded-2xl border border-white/8 bg-background-100 p-7 text-center">
                <p className="font-heading font-extrabold text-4xl md:text-5xl text-primary-400">
                  {card.value}
                </p>
                <p className="mt-3 text-sm text-foreground-600">{card.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10 text-center">
          <Link
            to="/results"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-6 py-3 font-label font-semibold text-sm border border-primary-500/40 text-foreground-950 hover:border-primary-500 hover:bg-primary-500/10 transition-all duration-300 hover:-translate-y-0.5">
            Explore Client Results
            <i className="ri-arrow-right-line"></i>
          </Link>
        </Reveal>

        <p className="mt-8 text-xs text-foreground-600 text-center max-w-2xl mx-auto leading-relaxed">
          Past performance and client results are illustrative. Individual
          results depend on market, offer, team, implementation, budget, and
          other business factors.
        </p>
      </div>
    </section>
  );
}
